import React from 'react';

const Button = (props) => {
  const { btnText } = props;
  return (
    <span className="btn-wrap">
      <span className="text-one">{btnText ? btnText : 'Discover More'}</span>
      <span className="text-two">{btnText ? btnText : 'Discover More'}</span>
    </span>
  );
};

export default Button;
